export default __webpack_public_path__ + "static/media/pexels-pavel-danilyuk-5495898.e2e32140.mp4";